<script>
import {
  iAccordion,
  iAccordionItem,
  iAccordionItemSizes,
  iBadge,
  iBadgeColours,
} from '@inscribe/signal';
import * as signalNames from '@/constants/signalNames';
import signalConfig from '@/constants/signalConfig';
import SignalButton from '@/V2/documents/document-view/SignalButton';

export default {
  components: {
    iAccordion,
    iAccordionItem,
    iBadge,
    SignalButton,
  },
  props: {
    document: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iAccordionItemSizes,
      iBadgeColours,
      signalNames,
    };
  },
  computed: {
    verifications() {
      const verificationsObject = this.document.verification;
      const signals = [];
      [
        signalNames.NAME,
        signalNames.ADDRESS,
        signalNames.COMPANY,
        signalNames.ID_NUMBER,
        signalNames.STRINGS,
      ]
        .filter((key) => Object.keys(verificationsObject).includes(key))
        .forEach((v) => {
          const verificationConfig = signalConfig[v];
          const verificationObject = verificationsObject[v];
          if (verificationObject.length) {
            verificationObject.forEach((vo) => {
              signals.push(this.getVerification(vo, verificationConfig));
            });
          } else {
            signals.push(
              this.getVerification(verificationObject, verificationConfig),
            );
          }
        });

      // signals sort by failed
      signals.sort((s1, s2) => (s1.verified > s2.verified ? 1 : -1));

      return signals;
    },
    verificationsFailed() {
      return this.verifications.filter((v) => !v.verified);
    },
  },
  methods: {
    getVerification(object, config) {
      object.failed = !object.verified;
      return {
        title: config.getTitle ? config.getTitle(object) : '',
        subtitle: object.verified ? object.matched : object.input,
        ...object,
      };
    },
    onButtonClicked(verification) {
      this.$emit('open-verification-details', verification);
    },
  },
};
</script>

<template>
  <i-accordion v-if="verifications.length" data-testid="verifications-list">
    <i-accordion-item
      title="Verifications"
      class="half-margin"
      :no-background="true"
      :mount-open="true"
      :size="iAccordionItemSizes.LARGE"
    >
      <!-- title -->
      <div slot="extra-title-content">
        <i-badge
          v-if="verificationsFailed.length > 0"
          :label="verificationsFailed.length + ' Failed'"
          :colour="iBadgeColours.NEUTRAL"
          :outline="true"
        ></i-badge>
        <i-badge
          v-if="verificationsFailed.length === 0"
          :label="'All Verified'"
          :colour="iBadgeColours.NEUTRAL"
          :outline="true"
        ></i-badge>
      </div>

      <!-- list -->
      <div class="verifications-list d-flex flex-column accordion-content">
        <signal-button
          v-for="(verification, verification_index) in verifications"
          :key="verification_index"
          :title="verification.title"
          :subtitle="verification.subtitle"
          :success="verification.verified"
          @button-click="onButtonClicked(verification)"
        ></signal-button>
      </div>
    </i-accordion-item>
  </i-accordion>
</template>

<style scoped lang="scss"></style>
